import { makeCrud } from "./crud";
import { request } from "./http";

const crud = makeCrud("invoices");

export const fetchInvoices  = (filters, signal) => crud.list(filters, signal);
export const fetchInvoice   = crud.get;
export const createInvoice  = crud.create;
export const updateInvoice  = crud.update;
export const deleteInvoice  = crud.remove;

/** payment = { amount, method, reference } — server updates paid/balance/status. */
export const recordPayment = (id, payment) =>
  request(`/invoices/${id}/payments`, { method: "POST", body: payment });
